export default "__VITE_ASSET__CYLU2iBx__"